import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api'
import { instanciaAxios } from '@/api'
import router from '@/router'

Vue.use(Vuex)

let store = new Vuex.Store({
  state: {
    accessToken: '',
    usuario: {
      nombre: '',
      rol: '',
      promociones: false,
      atributosRol: [],
      hashID: "",
      correoElectronico: null
    },
    tokenNotificaciones: ''
  },

  mutations: {
    CAMBIA_USUARIO (state, data) {      
      state.usuario.nombre = data.nombre;
      state.usuario.promociones = data.promo;
      state.usuario.correoElectronico = data.email;
      let datosUsuario = JSON.parse (localStorage.getItem('usuario'))
      datosUsuario.nombre = state.usuario.nombre;
      datosUsuario.promociones = state.usuario.promociones
      datosUsuario.correoElectronico = state.usuario.correoElectronico;
      
      localStorage.setItem ('usuario', JSON.stringify (datosUsuario));
      //console.log(JSON.stringify (datosUsuario));
    },

    ACCESS_TOKEN (state, accessToken) {
      if (accessToken != '') {
        localStorage.setItem ('accessToken', accessToken)
        api.establecerAccessToken (accessToken)
      } else {
        localStorage.clear ()
        api.eliminarAccessToken ()
      }
      state.accessToken = accessToken
    },

    USUARIO (state, datosUsuario) {
      localStorage.setItem ('usuario', JSON.stringify (datosUsuario))
      state.usuario.nombre = datosUsuario.nombre
      state.usuario.promociones = datosUsuario.promociones==undefined ? 0 : datosUsuario.promociones
      state.usuario.correoElectronico = datosUsuario.correoElectronico
      state.usuario.rol = datosUsuario.rol
      state.usuario.atributosRol = datosUsuario.atributosRol ? datosUsuario.atributosRol : []
      state.usuario.hashID = datosUsuario.hashID
    },

    TOKEN_NOTIFICACIONES (state, tokenNotificaciones) {
      state.tokenNotificaciones = tokenNotificaciones;
      if (store.getters.usuarioLogado)
        api.actualizarTokenNotificacionesUsuario (tokenNotificaciones)
    }
  },

  actions: {
    async INICIAR_SESION ({commit}, { email, password }) {
      let respuesta = await api.iniciarSesion (email, password, this.state.tokenNotificaciones)
      if (respuesta.data.accessToken != null) {
        commit ('ACCESS_TOKEN', respuesta.data.accessToken)
        commit ('USUARIO', respuesta.data.usuario)
        router.push ("/panel")
      }
      return respuesta
    },

    async CERRAR_SESION ({commit}) {
      try {
        await api.cerrarSesion ()
      } catch (e) {
        console.log (`Error al cerrar la sesión: ${e}`)
      }
      commit ('ACCESS_TOKEN', '')
      router.push ('/')
    },

    ESTABLECER_ESTADO_INICIAL ({commit}) {
      const datosUsuario = JSON.parse (localStorage.getItem('usuario'))
      const accessToken = localStorage.getItem('accessToken')
      if (datosUsuario && accessToken) {
        commit ('ACCESS_TOKEN', accessToken)
        commit ('USUARIO', datosUsuario)
      }
    }

  },

  getters: {
    usuarioLogado(state) {
      return (state.accessToken != '')
    }
  },


  modules: {
  }
})

// Añadimos un "interceptor" para tratar el error 401 cuando hay un usuario logado
instanciaAxios.interceptors.response.use (
  function (response) {
    return response
  },
  function (error) {
    if (401 === error.response.status && store.getters.usuarioLogado) {
        // borramos el token de sesion (cerramos la sesion de manera local) y nos vamos a la home page
        store.commit ('ACCESS_TOKEN', '')
        router.push ('/')
        alert ('La sesion ya no es válida. Por favor, ingrese de nuevo')
    } else {
        return Promise.reject(error)
    }
  }
)

export default store